import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import {EffectComposer} from 'three/examples/jsm/postprocessing/EffectComposer.js'
import {RenderPass} from 'three/examples/jsm/postprocessing/RenderPass.js'
import {DotScreenPass} from 'three/examples/jsm/postprocessing/DotScreenPass.js'
import {GlitchPass} from 'three/examples/jsm/postprocessing/GlitchPass.js'
import {ShaderPass} from 'three/examples/jsm/postprocessing/ShaderPass.js'
import {RGBShiftShader} from 'three/examples/jsm/shaders/RGBShiftShader.js'
import {GammaCorrectionShader} from 'three/examples/jsm/shaders/GammaCorrectionShader.js'
import {SMAAPass} from 'three/examples/jsm/postprocessing/SMAAPass.js'
import {UnrealBloomPass} from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'

import * as dat from 'lil-gui'
import { DirectionalLightHelper } from 'three'

// console.log(SMAAPass)

/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */
const gltfLoader = new GLTFLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()
const textureLoader = new THREE.TextureLoader()

/**
 * Update all materials
 */
const updateAllMaterials = () =>
{
    scene.traverse((child) =>
    {
        if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
        {
            child.material.envMapIntensity = 2.5
            child.material.needsUpdate = true
            child.castShadow = true
            child.receiveShadow = true
        }
    })
}

/**
 * Environment map
 */
const environmentMap = new THREE.Color('#ffffff')
// cubeTextureLoader.load([
//     '/textures/environmentMaps/0/px.jpg',
//     '/textures/environmentMaps/0/nx.jpg',
//     '/textures/environmentMaps/0/py.jpg',
//     '/textures/environmentMaps/0/ny.jpg',
//     '/textures/environmentMaps/0/pz.jpg',
//     '/textures/environmentMaps/0/nz.jpg'
// ])
environmentMap.encoding = THREE.sRGBEncoding

scene.background = environmentMap
scene.environment = environmentMap

const objectsDistance = 4


// Baked material
const bakedTexture = textureLoader.load('baked3.jpg')
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

/**
 * Models
 */
const model = gltfLoader.load(
    '/models/Self-bust/Self-3d-website-6.glb',
    (gltf) =>
    {
        gltf.scene.position.set(2.5,0,0)
        gltf.scene.scale.set(0.3, 0.3, 0.3)
        gltf.scene.rotation.y = Math.PI * 0.35
        // child.material = bakedMaterial
        scene.add(gltf.scene)

        updateAllMaterials()
    }
)

const sectionMeshes = [model]

/**
 * Lights
 */
const upColor = 0xFFFFFF
const downColor = 0x000FFF

const rectAreaLight = new THREE.RectAreaLight(upColor, 4, 20, 20)
const hemisphereLight = new THREE.HemisphereLight(upColor, downColor, 8)
const leftDirectionalLight = new THREE.DirectionalLight('#ffffff', 6)
const rightDirectionalLight = new THREE.DirectionalLight('#ffffff', 10)

leftDirectionalLight.castShadow = true
leftDirectionalLight.shadow.mapSize.set(1024, 1024)
leftDirectionalLight.shadow.camera.far = 15
leftDirectionalLight.shadow.normalBias = 0.05
const Helper = new DirectionalLightHelper(leftDirectionalLight, 0.2)

// rightLight.position.set()

leftDirectionalLight.position.set(-100,-61,100)
rightDirectionalLight.position.set(-9,-2,11)

scene.add(leftDirectionalLight, rightDirectionalLight, Helper)

// gui.add(leftDirectionalLight.position, 'x').min(-100).max(100).step(1).name('leftLightX')
// gui.add(leftDirectionalLight.position, 'y').min(-100).max(100).step(1).name('leftLightY')
// gui.add(leftDirectionalLight.position, 'z').min(-100).max(100).step(1).name('leftLightZ')
// gui.add(leftDirectionalLight, 'intensity').min(0).max(10).step(0.1).name('leftLightIntensity')
// gui.addColor(leftDirectionalLight, 'color')

// gui.add(rightDirectionalLight.position, 'x').min(-100).max(100).step(1).name('rightLightX')
// gui.add(rightDirectionalLight.position, 'y').min(-100).max(100).step(1).name('rightLightY')
// gui.add(rightDirectionalLight.position, 'z').min(-100).max(100).step(1).name('rightLightZ')
// gui.add(rightDirectionalLight, 'intensity').min(0).max(10).step(0.1).name('rightLightIntensity')
// gui.addColor(rightDirectionalLight, 'color')



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    //Update effect composer
    effectComposer.setSize(sizes.width, sizes.height)
    effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

//Camera Group
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
cameraGroup.add(camera)

// /**
//  * Camera
//  */
// // Base camera
// const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
// camera.position.set(4, 1, - 4)
// scene.add(camera)


// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFShadowMap
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ReinhardToneMapping
renderer.toneMappingExposure = 1.5
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

//Post processing

//Render target
const renderTarget = new THREE.WebGLRenderTarget(
    800, 
    600 
    // {
    //     // samples: renderer.getPixelRatio() === 1 ? 2: 0 
    // }
) 


const effectComposer = new EffectComposer(renderer, renderTarget)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
effectComposer.setSize(sizes.width, sizes.height)

//Render Pass
const renderPass = new RenderPass(scene, camera)
effectComposer.addPass(renderPass)

//Dot Screen pass
const dotScreenPass = new DotScreenPass()
dotScreenPass.enabled = false
dotScreenPass.strength = 0.5
effectComposer.addPass(dotScreenPass)

//Glitch pass
const glitchPass = new GlitchPass()
glitchPass.goWild = false
glitchPass.enabled = false
effectComposer.addPass(glitchPass)

//RGB Shift pass
const rgbShiftPass = new ShaderPass(RGBShiftShader)
rgbShiftPass.enabled = false
effectComposer.addPass(rgbShiftPass)

//Unreal Bloom pass
const unrealBloomPass = new UnrealBloomPass()
unrealBloomPass.strength = 0.377
unrealBloomPass.radius = 0
unrealBloomPass.threshold = 0.3
unrealBloomPass.enabled = true
effectComposer.addPass(unrealBloomPass)

// gui.add(unrealBloomPass, 'enabled')
// gui.add(unrealBloomPass, 'strength').min(0).max(2).step(0.001)
// gui.add(unrealBloomPass, 'radius').min(0).max(2).step(0.001)
// gui.add(unrealBloomPass, 'threshold').min(0).max(1).step(0.001)

// Tint pass
const TintShader = {
    uniforms: 
    {
        tDiffuse: {value: null},
        uTint: {value: null}
    },
    vertexShader: `
    varying vec2 vUv;

    void main()
    {
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        vUv = uv;
    }`,
    fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform vec3 uTint;

    varying vec2 vUv;

    void main()
    {
        vec4 color = texture2D(tDiffuse, vUv);
        color.rgb += uTint;
        gl_FragColor = color;
    }`
}

const tintPass = new ShaderPass(TintShader)
tintPass.material.uniforms.uTint.value = new THREE.Vector3()
effectComposer.addPass(tintPass)

// gui.add(tintPass.material.uniforms.uTint.value, 'x').min(-1).max(1).step(0.001).name('red')
// gui.add(tintPass.material.uniforms.uTint.value, 'y').min(-1).max(1).step(0.001).name('blue')
// gui.add(tintPass.material.uniforms.uTint.value, 'z').min(-1).max(1).step(0.001).name('green')

//Displacement pass
const DisplacementShader = {
    // uniforms: 
    // {
    //     tDiffuse: {value: null},
    //     uTime: {value: null}
    // },
    // vertexShader: `
    // varying vec2 vUv;

    // void main()
    // {
    //     gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    //     vUv = uv;
    // }`,
    // fragmentShader: `
    //     uniform sampler2D tDiffuse;
    //     uniform float uTime; 

    //     varying vec2 vUv;

    //     void main()
    //     {
    //         vec2 newUv = vec2(
    //             vUv.x,
    //             vUv.y + sin(vUv.x * 10.0 + uTime) * 0.1
    //         );

    //         vec4 color = texture2D(tDiffuse, newUv);
    //         gl_FragColor = color;
    //     }
    // `
    uniforms: 
    {
        tDiffuse: {value: null},
        uNormalMap: {value: null}
    },
    vertexShader: `
    varying vec2 vUv;

    void main()
    {
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        vUv = uv;
    }`,
    fragmentShader: `
        uniform sampler2D tDiffuse;
        uniform sampler2D uNormalMap;

        varying vec2 vUv;

        void main()
        {
            vec3 normalColor = texture2D(uNormalMap, vUv).xyz * 2.0 - 1.0;  

            vec2 newUv = vUv + normalColor.xy * 0.25;
            vec4 color = texture2D(tDiffuse, newUv);

            vec3 lightDirection = normalize(vec3(-1.0, 1.0, 0.0));
            float lightness = clamp(dot(normalColor, lightDirection), 0.0, 1.0);
            color.rgb += lightness * 2.0;

            gl_FragColor = color;
        }
    `
}

const displacementPass = new ShaderPass(DisplacementShader)
displacementPass.material.uniforms.uNormalMap.value = textureLoader.load('/textures/interfaceNormalMap.png')
// displacementPass.material.uniforms.uTime.value = 0
// effectComposer.addPass(displacementPass)

//Gamma correction pass
const gammaCorrectionShader = new ShaderPass(GammaCorrectionShader)
effectComposer.addPass(gammaCorrectionShader)

//SMAA pass
if(renderer.getPixelRatio === 1 && !renderer.capabilities.isWebGL2)
{
    const smaaPass = new SMAAPass()
    effectComposer.addPass(smaaPass)
}

//Scroll
let scrollY = window.scrollY
let currentSection = 0

window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY

    const newSection = Math.round(scrollY/sizes.height)

    if(newSection != currentSection)
    {
        currentSection = newSection

        gsap.to(
            sectionMeshes[currentSection].rotation,
            {
                duration: 1.5,
                ease: 'power2.inOut',
                x:'+= 6',
                y: '+=3',
                z: '+= 1.5'
            }
        )
        // console.log("changed", currentSection)

    }
})
//Cursor
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove', () =>
{
    cursor.x = event.clientX/sizes.width - 0.5
    cursor.y = event.clientY/sizes.height - 0.5
    // console.log(cursor)
})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    //Animate camera
    camera.position.y = - (scrollY/sizes.height * objectsDistance)

    const parallaxX = cursor.x 
    const parallaxY = - cursor.y 
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 2 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 2 * deltaTime

    //Update passes
    // displacementPass.material.uniforms.uTime.value = elapsedTime

    // Update controls
    // controls.update()

    // Render
    renderer.render(scene, camera)
    effectComposer.render()


    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()